// extracted by mini-css-extract-plugin
export default {"highlight-body":"styles_highlight-body__b0bzr"};